import { createFileRoute, redirect } from "@tanstack/react-router";

interface CompareAiSearchInput {
  items?: string;
  baseline?: string;
}

// Legacy Chart compare AI URL. The checklist now lives on `/compare`
// as `diffMode=ask-ai`. Replace the history entry so Back does not
// return to this route.
export const Route = createFileRoute("/compare-ai")({
  validateSearch: (raw: Record<string, unknown>): CompareAiSearchInput => ({
    items: typeof raw.items === "string" ? raw.items : undefined,
    baseline: typeof raw.baseline === "string" ? raw.baseline : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/compare",
      search: {
        items: search.items,
        baseline: search.baseline,
        diffMode: "ask-ai" as const,
      },
      replace: true,
    });
  },
});
